<template>
    <BreadCrumb PageTitle="Setup Definitions" />
    <QwilrInfo />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import QwilrInfo from "../../components/Qwilr/QwilrInfo.vue";
  
  export default defineComponent({
    name: "QwilrInfoPage",
    components: {
      BreadCrumb,
      QwilrInfo,
    },
  });
  </script>